






























































import Vue from "vue";
import {EntityService} from "@/services/entity.service";
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'
const entityService = new EntityService()

export default Vue.extend({
	name: 'AudioNew',
	mixins: [validationMixin],
	validations: {
		form: {
			name: {required, maxLength: maxLength(150)},
			file: {required}
		}
	},
	data: () => ({
		entity: 'audios',
		uploadFileUrl: 'uploadaudio',
		isLoading: false,
		form: {
			name: '',
			description: '',
			file: null
		},
		filename: null
	}),
	async created() {
		this.form = {
			name: '',
			description: '',
			file: null
		}
		this.filename = null
	},
	methods: {
		toggleModal (value: boolean) {
			this.$emit('input', value)
		},
		getExtension(fileName: string) {
			const re = /(?:\.([^.]+))?$/
			const result = re.exec(fileName)
			return (result && result.length > 0) ? result[1] : ''
		},
		async uploadFile (file: File) {
			if (!file) return
			if (!['MP3', 'FLAC', 'WAV'].includes(this.getExtension(file.name).toUpperCase())) {
				alert('Archivo inválido')
				this.form.file = null
				this.filename = null
			}
			this.isLoading = true
			const response = await entityService.uploadFile(this.entity, this.uploadFileUrl, file)
			if (response.url) this.filename = response.url
			else {
				this.form.file = null
				this.filename = null
			}
			this.isLoading = false
		},
		async save() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.isLoading = true
				const data = {
					name: this.form.name,
					description: this.form.description,
					filename: this.filename,
				}
				await entityService.createEntity(this.entity, data)
				this.isLoading = false
				this.$emit('input', false)
			}
		},
		getError: function (element: string) {
			const obj = this.$v['form'][element] || {$error: ''}
			if (obj.$error) return 'Campo requerido'
			return;
		}
	},
	props: ['value', '']
})
